exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-table[data-v-b7223c62] {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n.status-red[data-v-b7223c62] {\n  color: red;\n}\n.status-orange[data-v-b7223c62] {\n  color: orange;\n}\n.status-blue[data-v-b7223c62] {\n  color: blue;\n}\n", ""]);

// exports
